import React, { useMemo } from 'react';
import type { Skin } from 'c-entity-types';
import { css } from '@emotion/react';

type Props = {
    //
    small: boolean;
    dark?: boolean;
    DefaultLogo: React.FC;
    skin?: Skin;
};

const SvgLogoWrapper: React.FC<Props> = ({ DefaultLogo, skin, small, dark = false }) => {
    const logoSrc = useMemo(() => {
        // dark mode prefers the dark variant, falling back to the regular logo
        const candidates = small
            ? [dark ? skin?.logo_small_dark_path : null, skin?.logo_small_path]
            : [dark ? skin?.logo_dark_path : null, skin?.logo_path];

        return candidates.find(src => src != null && src.length > 0) ?? null;
    }, [skin, small, dark]);

    const imageProps = useMemo<any>(() => {
        let $imgProps: any = {
            children: <DefaultLogo />,
            height: '100%',
            width: '100%',
            // the default logo has no fill so would render black on a dark background. This only
            // reaches the fallback svg: uploaded logos are <img>s and svgs with their own fills win
            style: { maxWidth: '100%', alignSelf: 'center', fill: dark ? '#fff' : undefined },
        };

        if (small) {
            $imgProps = { ...$imgProps, css: css({ transition: 'all 300ms' }) };
        }

        if (logoSrc != null) {
            $imgProps.src = logoSrc;
            $imgProps.children = undefined;
        }

        return $imgProps;
    }, [small, DefaultLogo, logoSrc, dark]);

    if (logoSrc != null) {
        return <img alt="" {...imageProps} />;
    }
    return <svg {...imageProps} />;
};

export default SvgLogoWrapper;
